import { Text } from '@components/v2/ui';
import { TMesurabilityProject } from '@features/offsets/types';
import {
	Anchor,
	Box,
	Flex,
	NumberFormatter,
	NumberInput,
	Stack,
} from '@mantine/core';
import { getCurrencyUnit } from '@utils/currency-units';
import { useTranslation } from 'react-i18next';
import classes from './MeasurabilitiesOffsetSummaryCart.module.css';

type TMeasurabilitiesOffsetCardProps = {
	contribution: TMesurabilityProject;
	onQuantityChange: (
		id: string,
		newQuantity: number
	) => void;
	onRemove: (project: TMesurabilityProject) => void;
	name: string;
	quantity: number | undefined;
};

export const MeasurabilitiesOffsetCard: React.FC<
	TMeasurabilitiesOffsetCardProps
> = ({
	contribution,
	onQuantityChange,
	onRemove,
	name,
	quantity,
}) => {
	const { t } = useTranslation();

	return (
		<Box
			className={
				classes.containerMeasurabilitiesOffsetCard
			}
		>
			<Text
				variant="caption"
				c="var(--mantine-color-igluTextSecondary-9)"
			>
				{t('global.quantityInTco2e')}
			</Text>

			<Flex gap="14px" w="100%" justify="space-between">
				<Stack gap="0px">
					<Text
						variant="subtitle1"
						c="var(--mantine-color-igluTextPrimary-9)"
					>
						{name}
					</Text>

					<Text
						variant="caption"
						c="var(--mantine-color-igluTextSecondary-9)"
					>
						{`${contribution.sellPrice_europertco2eq ?? 0} €/tCO2e`}
					</Text>
				</Stack>

				<NumberInput
					placeholder="0"
					w={90}
					miw={90}
					radius="25px"
					value={quantity ?? 0}
					onChange={(value) =>
						onQuantityChange(
							contribution.id,
							Number(value)
						)
					}
				/>
			</Flex>

			<Flex
				w="100%"
				justify="space-between"
				align="center"
			>
				<Anchor
					onClick={() => onRemove(contribution)}
					underline="always"
					c="var(--mantine-color-igluRed-9)"
				>
					{t('global.delete')}
				</Anchor>

				<Text
					variant="subtitle1"
					c="var(--mantine-color-igluBlue-9)"
				>
					<NumberFormatter
						suffix={getCurrencyUnit('EUR')}
						value={
							(contribution.sellPrice_europertco2eq ??
								0) * (quantity ?? 0)
						}
						decimalScale={2}
						thousandSeparator=" "
					/>
				</Text>
			</Flex>
		</Box>
	);
};
